/* Maps each snapshot key to the selection map (nodeId -> selectionId) and the
 * committed values (selectionId -> value) it is derived from. Returns undefined
 * when no Tacton data is loaded yet. */
var getSelectionFields = function (state) {
    var data = state.dataState.data;
    if (!data)
        return undefined;
    return {
        cup: {
            selectionMap: state.cupSelectionMap,
            selections: data.suctionCupSelections,
        },
        cupMounting: {
            selectionMap: state.cupMountingSelectionMap,
            selections: data.cupMountingSelections,
        },
        cupTechnology: {
            selectionMap: state.cupTechnologySelectionMap,
            selections: data.cupTechnologySelections,
        },
        pumpCentral: {
            selectionMap: state.pumpSelectionCentralMap,
            selections: data.vacuumPumpSelectionsCentralized,
        },
        pumpDecentral: {
            selectionMap: state.pumpSelectionDecentralMap,
            selections: data.vacuumPumpSelectionsDecentralized,
        },
    };
};
/* Captures the values currently committed to Tacton for a node so they can be
 * re-committed if a delete of that node is undone. */
export var getNodeSelectionSnapshot = function (state, nodeId) {
    var fields = getSelectionFields(state);
    var snapshot = {};
    if (!fields)
        return snapshot;
    Object.keys(fields).forEach(function (key) {
        var _a = fields[key], selectionMap = _a.selectionMap, selections = _a.selections;
        var selectionId = selectionMap[nodeId];
        var value = selectionId ? selections[selectionId] : undefined;
        if (value)
            snapshot[key] = value;
    });
    return snapshot;
};
/* The selection ids that currently hold a committed value for a node. These are
 * the parameters that must be cleared in Tacton when the node is deleted. */
export var getCommittedSelectionIds = function (state, nodeId) {
    var fields = getSelectionFields(state);
    if (!fields)
        return [];
    var ids = [];
    Object.values(fields).forEach(function (_a) {
        var selectionMap = _a.selectionMap, selections = _a.selections;
        var selectionId = selectionMap[nodeId];
        if (selectionId && selections[selectionId])
            ids.push(selectionId);
    });
    return ids;
};
/* Whether the node is mapped to any selection slot at all (committed or not). */
export var nodeHasAnySelection = function (state, nodeId) {
    return !!state.cupSelectionMap[nodeId] ||
        !!state.cupMountingSelectionMap[nodeId] ||
        !!state.cupTechnologySelectionMap[nodeId] ||
        !!state.pumpSelectionCentralMap[nodeId] ||
        !!state.pumpSelectionDecentralMap[nodeId];
};
